export default __webpack_public_path__ + "static/media/icon_intelligence_interpersonal.eb466aa5.svg";